"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const venmobutton = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 343 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-venmobutton` : '') + (description ? ` desc-venmobutton` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-venmobutton"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-venmobutton"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H323C334.046 0 343 8.95431 343 20V20C343 31.0457 334.046 40 323 40H20C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.794 13.0494C147.291 13.8647 147.515 14.7044 147.515 15.7651C147.515 19.1483 144.607 23.5433 142.247 26.6294H136.857L134.695 13.7902L139.415 13.3451L140.558 22.481C141.626 20.753 142.944 18.0373 142.944 16.1857C142.944 15.1723 142.769 14.482 142.496 13.9136L146.794 13.0494Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.911 18.7031C153.78 18.7031 155.967 18.3085 155.967 17.0741C155.967 16.4814 155.545 16.1857 155.047 16.1857C154.177 16.1857 153.036 17.2219 152.911 18.7031ZM152.812 21.1477C152.812 22.6549 153.656 23.2462 154.774 23.2462C155.992 23.2462 157.159 22.9506 158.675 22.1854L158.104 26.0364C157.036 26.5548 155.371 26.9006 153.755 26.9006C149.657 26.9006 148.19 24.4319 148.19 21.3457C148.19 17.3456 150.576 13.0982 155.495 13.0982C158.204 13.0982 159.718 14.6053 159.718 16.7038C159.718 20.0869 155.347 21.1233 152.812 21.1477Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.339 16.0623C173.339 16.556 173.264 17.2722 173.189 17.7402L171.772 26.6293H167.176L168.468 18.4808C168.493 18.2598 168.568 17.8149 168.568 17.568C168.568 16.9753 168.195 16.8274 167.747 16.8274C167.152 16.8274 166.555 17.0987 166.157 17.2968L164.692 26.6294H160.07L162.182 13.3209H166.182L166.233 14.3831C167.176 13.766 168.419 13.0985 170.182 13.0985C172.518 13.0982 173.339 14.2838 173.339 16.0623Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.983 14.5551C188.299 13.6178 189.542 13.0982 191.256 13.0982C193.616 13.0982 194.437 14.2838 194.437 16.0623C194.437 16.556 194.362 17.2722 194.287 17.7402L192.872 26.6293H188.275L189.591 18.3086C189.616 18.0862 189.666 17.8149 189.666 17.6428C189.666 16.9754 189.293 16.8274 188.845 16.8274C188.274 16.8274 187.704 17.0742 187.28 17.2968L185.815 26.6294H181.219L182.536 18.3087C182.56 18.0863 182.609 17.815 182.609 17.6429C182.609 16.9755 182.236 16.8275 181.79 16.8275C181.193 16.8275 180.597 17.0988 180.2 17.2969L178.734 26.6295H174.113L176.224 13.321H180.176L180.3 14.4321C181.219 13.7662 182.461 13.0987 184.125 13.0987C185.566 13.0982 186.51 13.7155 186.983 14.5551Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.583 18.432C203.583 17.3456 203.31 16.6048 202.491 16.6048C200.677 16.6048 200.304 19.7897 200.304 21.4189C200.304 22.6549 200.653 23.4198 201.472 23.4198C203.186 23.4198 203.583 20.0611 203.583 18.432ZM195.634 21.2222C195.634 17.0253 197.869 13.0982 203.013 13.0982C206.888 13.0982 208.305 15.3704 208.305 18.5065C208.305 22.6548 206.094 26.9507 200.826 26.9507C196.926 26.9507 195.634 24.4072 195.634 21.2222Z",
    fill: "white"
  }));
};
var _default = exports.default = venmobutton;